<template>
    <v-container fluid fill-height>
        <v-layout class="align-center justify-center">
            <v-flex text-center>
                <h1 class="display-2 primary--text">¡Uuups! Error 404</h1>
                <p class="my-6">No hemos encontrado lo que estas buscando.</p>
                <v-btn to="/" color="primary" class="secondary--text" x-large>Ir al Inicio</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: "NotFound"
}
</script>
